import React from "react";
import { fileNameHelper } from "../amorg-common";
import { iconName, Icon } from "./icons/Icons";


type FileExtensionIconProps = {
    filename:string
}

export function getFileExtensionIconProps(filename:string): { color?: string, name:iconName }
{
    const ext = fileNameHelper.getSupportedFileExtension(filename);

    switch (ext) {
        case 'csv':
            return { color: "#16a34a", name: 'file_csv' };

        case 'xls':
        case 'xlsx':
            return { color: '#217346', name: 'file_excel' };

        case 'mov':
        case 'mp4':
            return { color: '#6d28d9', name: 'file_film' };

        case 'gif':
        case 'jpg':
        case 'jpeg':
        case 'png':
            return { color: "#0ea5e9", name: 'file_image' };

        case 'pdf':
            return { color: "#dc2626", name: 'file_pdf' };

        case 'txt':
        case 'rtf':
            return { color: "#64748b", name: 'file_text' };

        case 'doc':
        case 'docx':
            return { color: "#1e40af", name: 'file_word' };

        default:
            return { name: 'file' };
    }
}

export function FileExtensionIcon(props:FileExtensionIconProps):JSX.Element
{
    return <Icon {...getFileExtensionIconProps(props.filename)} />;
}